import React, { useEffect } from "react";
import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Store } from "@/components/Store";
import { StudioPreview } from "@/components/StudioPreview";
import { Features } from "@/components/Features";
import { KarateGis } from "@/components/KarateGis";
import { Showcase } from "@/components/Showcase";
import { Install } from "@/components/Install";
import { Faq } from "@/components/Faq";
import { FinalCta } from "@/components/FinalCta";
import { Footer } from "@/components/Footer";

export default function Home() {
  useEffect(() => {
    const hash = window.location.hash;
    if (!hash || hash === "#top") return;
    const t = setTimeout(() => {
      document.querySelector(hash)?.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 400);
    return () => clearTimeout(t);
  }, []);

  return (
    <main className="relative bg-[#08080a]">
      <Nav />
      <Hero />
      <Marquee />
      <Store />
      <StudioPreview />
      <Features />
      <KarateGis />
      <Showcase />
      <Install />
      <Faq />
      <FinalCta />
      <Footer />
    </main>
  );
}
